import { useState,useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import useCurrentTeacher from '../../../hooks/useCurrentTeacher';
import Filters from '../Filters';
import useCategories from '../../../hooks/useCategories'
const BASE_URL = process.env.REACT_APP_BASE_URL;

const ListAudios = () => {
    const navigate=useNavigate()
    const {search,setSearch,category,setCategory,categories}=useCategories()
    const {teacher}=useCurrentTeacher()
    const [audioCourses, setAudioCourses] = useState([]);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
      if (!teacher?.id) return; 
    
      setLoading(true); // start loading
    
      fetch(`${BASE_URL}/courses/audios/?teacher_id=${teacher.id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('access_token')}`,
          'Content-Type': 'application/json',
          "x-api-key": process.env.REACT_APP_X_API_KEY
        },
      })
        .then(res => res.json())
        .then(data => {
          if (Array.isArray(data)) setAudioCourses(data);
          else if (data.results && Array.isArray(data.results)) setAudioCourses(data.results);
          else setAudioCourses([]);
          setLoading(false); 
        })
        .catch(err => {
          console.error(err);
          setLoading(false);
        });
    }, [teacher?.id]);
    const filteredSearch=audioCourses.filter((item)=>item.name.toLocaleLowerCase().includes(search))
  const filteredCourses = filteredSearch.filter(
  item => !category || item.category_name === category
);
  return (
  <div className="min-h-screen px-4 p-6">

  {/* Header */}
  <div className="flex flex-col md:flex-row md:justify-between md:items-start gap-6 mb-8 max-w-6xl mx-auto">
    <div className="flex-1">
      <div className="flex items-center gap-3 mb-3">
        <div className="w-10 h-10 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
          <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 19V6l12-3v13M9 19c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zm12-3c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zM9 10l12-3" />
          </svg>
        </div>
        <h1 className="text-3xl md:text-4xl font-bold text-gray-900">
          Audio Library
        </h1>
      </div>
      <p className="text-gray-500 ml-13">
        Collection of all audio files with detailed information and playback
      </p>
    </div>

    <button
      onClick={() => navigate('/teacher/audios/upload',{state:{type:'Audio'}})}
      className="px-6 py-3 bg-[#0f6abf] text-white font-medium rounded-xl hover:bg-[#0a5ca8] transition-colors flex items-center gap-2 shadow-sm"
    >
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" />
      </svg>
      Add New Audio
    </button>
  </div>

  <Filters
    search={search}
    setSearch={setSearch}
    category={category}
    setCategory={setCategory}
    categories={categories}
  />

  {/* Loading Skeleton */}
  {loading
  ? Array.from({ length: 6 }).map((_, idx) => (
      <div
        key={idx}
        className="bg-white rounded-xl border border-gray-200 overflow-hidden flex flex-col h-full animate-pulse"
      >
        {/* Video Area */}
        <div className="w-full h-48 bg-gray-200" />

        <div className="p-5 flex flex-col flex-1">
          
          {/* Top badges row */}
          <div className="flex justify-between mb-3">
            <div className="h-6 w-20 bg-gray-200 rounded-lg" />
            <div className="h-6 w-16 bg-gray-200 rounded-lg" />
          </div>

          {/* Title */}
          <div className="h-6 bg-gray-200 rounded w-3/4 mb-4" />

          {/* Tags */}
          <div className="flex gap-2 mb-4">
            <div className="h-6 w-24 bg-gray-200 rounded-lg" />
            <div className="h-6 w-24 bg-gray-200 rounded-lg" />
          </div>

          {/* Description lines */}
          <div className="space-y-2 mb-4 flex-1">
            <div className="h-4 bg-gray-200 rounded w-full" />
            <div className="h-4 bg-gray-200 rounded w-5/6" />
            <div className="h-4 bg-gray-200 rounded w-2/3" />
          </div>

          {/* Button */}
          <div className="h-10 bg-gray-200 rounded-xl mt-auto" />
        </div>
      </div>
    ))
  : (

    <div className="flex flex-wrap gap-6 max-w-6xl mx-auto justify-center mt-10">
      {filteredCourses?.map((audio) => (
        <div
          key={audio.id}
          className="flex flex-col flex-1 min-w-[280px] basis-full sm:basis-[48%] lg:basis-[31%] bg-white rounded-2xl border border-gray-200 p-6 hover:border-[#0f6abf] hover:shadow-md transition-all duration-200"
        >

           {/* Audio Player */}
          <audio
            controls
            className="w-full mt-2 rounded-lg"
          >
            <source src={audio.file} type="audio/mpeg" />
            Your browser does not support the audio element.
          </audio>
         <div className="mt-3 flex justify-between">
                <div className="flex items-center gap-2 mb-3">
                <span className="text-xs font-medium px-2.5 py-1 bg-[#e8f0f7] text-[#0f6abf] rounded-lg">
                  {audio.course_type}
                </span>
              </div>
              {audio.course_type !== 'free' && (
                 <div className="flex items-center gap-2 mb-3">
                <span className="text-xs font-medium px-2.5 py-1 bg-[#e8f0f7] text-[#0f6abf] rounded-lg">
                  ${audio.price}
                </span>
              </div>
              )}
               </div>
          <div className="mt-3 flex items-center gap-2 mb-2">
                <h3 className="text-xl font-semibold text-gray-900">
                  {audio.name}
                </h3>
              </div>
          {/* Card Header */}
         
           
            

            <div className="mt-3 flex flex-wrap gap-2">
                  <span className="text-xs px-3 py-1.5 bg-gray-100 text-gray-700 rounded-lg">
                    {audio.category_name}
                  </span>
                  <span className="text-xs px-3 py-1.5 bg-gray-100 text-gray-700 rounded-lg">
                    {audio.subcategory_name}
                  </span>
                </div>
          

          
        

          {/* Description */}
          <p className="mt-3 text-sm text-gray-600 leading-relaxed mb-4">
            {audio.description.split(' ').slice(0,20).join(' ')}
            {audio.description.split(' ').length > 20 && '...'}
          </p>

         
          {/* View Button */}
          <button
            onClick={() => navigate(`/teacher/audios/audio/${audio.learning_type}/${audio.id}`)}
            className="w-full flex gap-4 items-center justify-center py-3 bg-[#0f6abf] text-white text-sm font-medium rounded-xl hover:bg-[#0a5ca8] transition-colors mt-auto"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
            </svg>
            View Detail
          </button>

        </div>
      ))}
    </div>
  )}
</div>
  );
};

export default ListAudios;